import { Stack, useLocalSearchParams } from 'expo-router';
import { moderationDashModuleQuery, useModule } from 'system/structure-modules';

export default function ModerationDashboardSpacesSpaceScreen() {
    const { ModerateInstanceScreen } = useModule(moderationDashModuleQuery);
    const { instanceKey } = useLocalSearchParams<'/[siloKey]/moderationdash/one/spaces/[instanceKey]'>();
    return (
        <>
            <Stack.Screen options={{ title: instanceKey }} />
            <ModerateInstanceScreen instanceKey={instanceKey} structureKey='question' />
        </>
    );
}
